import * as React from 'react';
import { NavLink } from 'react-router-dom';
import './SchoolSettingsTabs.scss';

export const SchoolSettingsTabs: React.FunctionComponent<{ isUnion?: boolean }> = ({ isUnion = false }) => (
  <nav className="schoolSettingsTabs" role="tablist" aria-label="School settings sections">
    {isUnion ? (
      <>
        <NavLink
          exact
          to="/school/setup"
          className="schoolSettingsTabs__item"
          activeClassName="schoolSettingsTabs__item--active"
          role="tab"
        >
          Setup centre
        </NavLink>
        <NavLink
          exact
          to="/union/settings/general"
          className="schoolSettingsTabs__item"
          activeClassName="schoolSettingsTabs__item--active"
          role="tab"
        >
          General
        </NavLink>
        <NavLink
          to="/union/settings/public-site"
          className="schoolSettingsTabs__item"
          activeClassName="schoolSettingsTabs__item--active"
          role="tab"
        >
          Public site
        </NavLink>
        <NavLink
          to="/union/settings/website-widgets"
          className="schoolSettingsTabs__item"
          activeClassName="schoolSettingsTabs__item--active"
          role="tab"
        >
          Website widgets
        </NavLink>
        <NavLink
          to="/union/settings/big-screen"
          className="schoolSettingsTabs__item"
          activeClassName="schoolSettingsTabs__item--active"
          role="tab"
        >
          Big screen
        </NavLink>
        <NavLink
          to="/union/settings/tournament-communications"
          className="schoolSettingsTabs__item"
          activeClassName="schoolSettingsTabs__item--active"
          role="tab"
        >
          Tournament chats
        </NavLink>
      </>
    ) : (
      <>
        <NavLink
          exact
          to="/school/settings/base"
          className="schoolSettingsTabs__item"
          activeClassName="schoolSettingsTabs__item--active"
          role="tab"
        >
          Profile
        </NavLink>
        <NavLink
          to="/school/settings/public-site"
          className="schoolSettingsTabs__item"
          activeClassName="schoolSettingsTabs__item--active"
          role="tab"
        >
          Public site
        </NavLink>
        <NavLink
          to="/school/settings/big-screen"
          className="schoolSettingsTabs__item"
          activeClassName="schoolSettingsTabs__item--active"
          role="tab"
        >
          Big screen
        </NavLink>
        <NavLink
          to="/school/settings/website-widgets"
          className="schoolSettingsTabs__item"
          activeClassName="schoolSettingsTabs__item--active"
          role="tab"
        >
          Website widgets
        </NavLink>
        <NavLink
          to="/school/settings/gm-email"
          className="schoolSettingsTabs__item"
          activeClassName="schoolSettingsTabs__item--active"
          role="tab"
        >
          General messages
        </NavLink>
        <NavLink
          to="/school/settings/event-communications"
          className="schoolSettingsTabs__item"
          activeClassName="schoolSettingsTabs__item--active"
          role="tab"
        >
          Chats
        </NavLink>
        <NavLink
          to="/school/settings/availability"
          className="schoolSettingsTabs__item"
          activeClassName="schoolSettingsTabs__item--active"
          role="tab"
        >
          Availability
        </NavLink>
        <details className="schoolSettingsTabs__more">
          <summary aria-label="More school settings">•••</summary>
          <div>
            <NavLink to="/school/settings/advanced" activeClassName="is-active">
              Advanced
            </NavLink>
            <NavLink to="/school/settings/subscriptions" activeClassName="is-active">
              Subscriptions
            </NavLink>
            <NavLink to="/school/settings/payment-accounts" activeClassName="is-active">
              Payment accounts
            </NavLink>
          </div>
        </details>
      </>
    )}
  </nav>
);

SchoolSettingsTabs.displayName = 'SchoolSettingsTabs';
